import React, { useState, useEffect,useRef } from 'react';
import { Modal } from 'antd';
import emiter, {_EVENTS } from '../../../../events'

interface props {}

const Com: React.FC<props> = (props) => {

  const [open, setOpen] = useState(false);
  const dataRef: any = useRef({});
  const [data, setData] = useState<any>({});


  const openModal = (params: any) => {
        dataRef.current = params || {};
        setData(params)
        setOpen(true);
  };

  const onClose = () => {
      setOpen(false);
  };

  useEffect(() => {
    emiter.on(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.MODAL, openModal);
    return () => {
      emiter.removeAllListeners(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.MODAL)
    }
  },[])
    return (
      <Modal open={open} onCancel={onClose} title={data.title} footer={null} width={1000}>
        <div>{data.brief}</div>
        <div dangerouslySetInnerHTML={{ __html: data.content }} className='richContent' style={{overflow:'hidden',overflowX: 'auto'}}></div>
      </Modal>
    )
}

export default Com